import { useTranslation } from "react-i18next";
import { SelectInput } from "../../../components/SelectInput";
import { InvoiceCustomerDisplayField } from "@KassaroAB/shared/types/enums/InvoiceCustomerDisplayField";
import { FieldRow } from "./paymentMethodFields";

const CUSTOMER_DISPLAY_FIELD_OPTIONS = [
  InvoiceCustomerDisplayField.YOUR_REFERENCE,
  InvoiceCustomerDisplayField.OUR_REFERENCE,
  InvoiceCustomerDisplayField.ORG_NUMBER,
  InvoiceCustomerDisplayField.EMAIL,
  InvoiceCustomerDisplayField.PHONE,
  InvoiceCustomerDisplayField.CITY,
  InvoiceCustomerDisplayField.ADDRESS1,
  InvoiceCustomerDisplayField.CUSTOMER_NUMBER,
] as const;

const isCustomerDisplayField = (
  value: string,
): value is InvoiceCustomerDisplayField =>
  CUSTOMER_DISPLAY_FIELD_OPTIONS.some((option) => option === value);

type CustomerDisplayFieldSelectProps = {
  label: string;
  value?: InvoiceCustomerDisplayField;
  onChange: (value?: InvoiceCustomerDisplayField) => void;
  onBlur?: () => void;
};

export const CustomerDisplayFieldSelect = ({
  label,
  value,
  onChange,
  onBlur,
}: CustomerDisplayFieldSelectProps) => {
  const { t } = useTranslation();
  return (
    <FieldRow label={label}>
      <SelectInput
        value={value ?? ""}
        onChange={(e) =>
          onChange(
            isCustomerDisplayField(e.target.value) ? e.target.value : undefined,
          )
        }
        onBlur={onBlur}
      >
        <option value="">{t("paymentMethodForm.noneSelected")}</option>
        {CUSTOMER_DISPLAY_FIELD_OPTIONS.map((field) => (
          <option key={field} value={field}>
            {t(`paymentMethodForm.customerDisplayField.${field}`)}
          </option>
        ))}
      </SelectInput>
    </FieldRow>
  );
};
